import React, { useState, useEffect, useContext } from "react";
import "./forma.css";
import Axios from "axios";
import { API_URL } from "../components/api";

import Select from "react-select";
import AuthContext from "../context/AuthContext";
import LanguageContext from "../context/LanguageContext";

function Form(props) {
  let [notes, setvillage] = useState([]);
  let [employee, setemployee] = useState([]);
  let [remote, setRemote] = useState(0); // New state for remote, default value 0
  let [office,setOffice]=useState(0)
  let [potential,setPotential]=useState(0)
  let [freeCollection, setFreeCollection] = useState(0);
  console.log(remote);
  let { user } = useContext(AuthContext);
  const { language, t } = useContext(LanguageContext);
  const isAr = language === "ar";
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));

  function refreshPage() {
    window.location.reload(false);
  }

  useEffect(() => {
    let isMounted = true;

    const getvillage = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/villages/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: "admin",
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setvillage(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getemployee = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/employees/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: "admin",
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setemployee(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getvillage();
    getemployee();

    return () => {
      isMounted = false;
    };
  }, []);

  const options = notes.map((item) => {
    return {
      label: isAr ? item.village_name_ar || "" : item.village_name,
      value: item.village_id,
    };
  });

  const employees = employee.map((item) => {
    return {
      label: item.first_name,
      value: item.employee_id,
    };
  });

  const [firstname, setfirst] = useState("");
  const [middlename, setmiddles] = useState("");
  const [lastname, setlast] = useState("");
  const [firstnameAr, setfirstAr] = useState("");
  const [middlenameAr, setmiddleAr] = useState("");
  const [lastnameAr, setlastAr] = useState("");
  const [address, setaddress] = useState("");
  const [phone, setphone] = useState("");
  const [village, setvill] = useState("");
  const [category, setcategory] = useState("");

  const [collector, setcollector] = useState("");

  console.log(village);

  const AR_ONLY = /^[\u0600-\u06FF\s]+$/;
  const NO_AR = /^[^\u0600-\u06FF]+$/;

  const validate = () => {
    return (
      NO_AR.test(firstname) &&
      NO_AR.test(middlename) &&
      NO_AR.test(lastname) &&
      AR_ONLY.test(firstnameAr) &&
      AR_ONLY.test(middlenameAr) &&
      AR_ONLY.test(lastnameAr) &&
      phone !== "" &&
      village !== "" &&
      category !== "" &&
      address !== ""
    );
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(
      `${API_URL}/administration/clients/`,
      {
        Action: "Post",
        first_name: firstname,
        email_address: "-",
        address_string: address,
        phone_number: phone,
        middle_name: middlename,
        last_name: lastname,
        first_name_ar: firstnameAr,
        middle_name_ar: middlenameAr,
        last_name_ar: lastnameAr,
        userdealer: user.username,
        collector_id: collector,
        category: category,
        village_id: village,
        remote: remote, // Include remote in the POST request payload
        office:office,
        potential:potential,
        free_collection: freeCollection,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        refreshPage();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const dua = [
    { value: "VIP", label: t("clientsPage.categories.VIP") },
    { value: "Standard", label: t("clientsPage.categories.Standard") },
    { value: "Special", label: t("clientsPage.categories.Special") },
    { value: "Blacklist", label: t("clientsPage.categories.Blacklist") },
  ];
  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="name">
            <div className="form-group">
              <label>
                {t("clientForm.firstName")}
                <input
                  className="form-control"
                  type="text"
                  value={firstname}
                  required
                  placeholder={t("clientForm.phFirstName")}
                  onChange={(e) => {
                    setfirst(e.target.value);
                  }}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                {t("clientForm.middleName")}
                <input
                  className="form-control"
                  type="text"
                  value={middlename}
                  required
                  placeholder={t("clientForm.phMiddleName")}
                  onChange={(e) => setmiddles(e.target.value)}
                />
              </label>
            </div>

            <div className="form-group">
              <label>
                {t("clientForm.lastName")}
                <input
                  className="form-control"
                  type="text"
                  value={lastname}
                  required
                  placeholder={t("clientForm.phLastName")}
                  onChange={(e) => setlast(e.target.value)}
                />
              </label>
            </div>
          </div>

          <div className="name">
            <div className="form-group">
              <label>
                {t("clientForm.firstNameAr")}
                <input
                  className="form-control"
                  type="text"
                  dir="rtl"
                  value={firstnameAr}
                  required
                  placeholder={t("clientForm.phFirstNameAr")}
                  onChange={(e) => setfirstAr(e.target.value)}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                {t("clientForm.middleNameAr")}
                <input
                  className="form-control"
                  type="text"
                  dir="rtl"
                  value={middlenameAr}
                  required
                  placeholder={t("clientForm.phMiddleNameAr")}
                  onChange={(e) => setmiddleAr(e.target.value)}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                {t("clientForm.lastNameAr")}
                <input
                  className="form-control"
                  type="text"
                  dir="rtl"
                  value={lastnameAr}
                  required
                  placeholder={t("clientForm.phLastNameAr")}
                  onChange={(e) => setlastAr(e.target.value)}
                />
              </label>
            </div>
          </div>

          <label>
            {t("clientForm.phone")}
            <input
              className="form-control"
              type="number"
              value={phone}
              required
              placeholder={t("clientForm.phPhone")}
              onChange={(e) => setphone(e.target.value)}
            />
          </label>

          <label>
            {t("clientForm.village")}
            <Select
              className="search-line"
              placeholder={t("clientForm.phVillage")}
              options={options}
              onChange={(opt) => setvill(opt.value)}
            />
          </label>

          <label>
            {t("clientForm.address")}
            <input
              className="form-control"
              type="text"
              value={address}
              required
              placeholder={t("clientForm.phAddress")}
              onChange={(e) => setaddress(e.target.value)}
            />
          </label>
          <div className="form-group">
            <label>
              {t("clientForm.collector")}
              <Select
                className="search-line"
                required
                placeholder={t("clientForm.phSelect")}
                options={employees}
                onChange={(opt) => setcollector(opt.value)}
              />
            </label>
            <label>
              {t("clientForm.category")}
              <Select
                className="search-line"
                placeholder={t("clientForm.phSelect")}
                options={dua}
                onChange={(opt) => setcategory(opt.value)}
              />
            </label>
            {/* Checkbox for remote */}

            <div
              className="form-group"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label style={{ marginRight: "10px" }}>{t("clientForm.tempCollection")}</label>
              <input
                type="checkbox"
                checked={remote === 1}
                onChange={(e) => setRemote(e.target.checked ? 1 : 0)}
                style={{ width: "20px", height: "20px" }}
              />
            </div>
            <div
              className="form-group"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label style={{ marginRight: "10px" }}>{t("clientForm.tempCollectionOffice")}</label>
              <input
                type="checkbox"
                checked={office === 1}
                onChange={(e) => setOffice(e.target.checked ? 1 : 0)}
                style={{ width: "20px", height: "20px" }}
              />
            </div>
            <div
            className="form-group"
            style={{ display: "flex", alignItems: "center" }}
          >
            <label style={{ marginRight: "10px" }}>{t("clientForm.potentialClient")}</label>
            <input
              type="checkbox"
              checked={potential === 1}
              onChange={(e) => setPotential(e.target.checked ? 1 : 0)}
              style={{ width: "20px", height: "20px" }}
            />
          </div>
          <div
            className="form-group"
            style={{ display: "flex", alignItems: "center" }}
          >
            <label style={{ marginRight: "10px" }}>
              {t("clientForm.freeCollection")}
            </label>
            <input
              type="checkbox"
              checked={freeCollection === 1}
              onChange={(e) =>
                setFreeCollection(e.target.checked ? 1 : 0)
              }
              style={{ width: "20px", height: "20px" }}
            />
          </div>
          </div>

          <div className="fo">
            <button
              type="submit"
              className="btn btn-primary btn-md"
              onClick={() => {
                props.parentFunction();
              }}
              disabled={!validate()}
            >
              {t("clientForm.create")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Form;
